import { Car } from "lucide-react";
import { useLang, scrollToId } from "@/lang";

const Footer = () => {
  const { lang, setLang, t } = useLang();

  return (
    <footer data-testid="footer" className="relative border-t border-amber-500/10 py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-badge.png" alt="Kenny Cab" className="w-10 h-10 rounded-full object-cover border border-amber-600/40" />
              <span className="font-serif text-lg text-ivory">Kenny <span className="italic text-champagne">Cab</span></span>
            </div>
            <div data-testid="footer-status" className="flex items-center gap-2.5 mt-5 text-xs text-zinc-500">
              <span className="status-dot w-2 h-2 rounded-full bg-emerald-400 inline-block" />
              {t.footer?.status}
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {["services", "booking", "testimonials", "contact"].map((id) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-xs uppercase tracking-[0.2em] text-zinc-500 hover:text-champagne transition-colors">
                {t.nav?.[id]}
              </button>
            ))}
          </nav>

          <div className="flex flex-col items-start md:items-end gap-3">
            <button
              data-testid="footer-lang-toggle"
              onClick={() => setLang(lang === "fr" ? "en" : "fr")}
              className="text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-champagne border border-amber-500/20 hover:border-amber-400/60 rounded-full px-4 py-2 transition-colors duration-300"
            >
              {lang === "fr" ? "English" : "Français"}
            </button>
            <div className="flex gap-6 text-[11px] text-zinc-600">
              <span data-testid="footer-legal" className="hover:text-zinc-400 cursor-pointer transition-colors">{t.footer?.legal}</span>
              <span data-testid="footer-privacy" className="hover:text-zinc-400 cursor-pointer transition-colors">{t.footer?.privacy}</span>
              <a data-testid="footer-tarifs-link" href="/tarifs" className="hover:text-zinc-400 transition-colors">{t.nav?.tarifs}</a>
              <a data-testid="footer-admin-link" href="/admin" className="hover:text-zinc-400 transition-colors">Espace pro</a>
            </div>
          </div>
        </div>

        <div className="gold-hairline w-full my-10" />
        <p data-testid="footer-copyright" className="text-center text-[11px] tracking-wider text-zinc-600">{t.footer?.rights}</p>
      </div>
    </footer>
  );
};

export default Footer;
